import { instance } from '@/Utils/axios';

export default {
  // 代工配方-列表
  getOEMFormulaPage: data => instance.post('/nhf-app/oemFormulaManage/getOemFormulaManagePage', data),

  // 更新配方
  updateOemFormula: data => instance.post('/nhf-app/oemFormulaManage/updateOemFormula', data),


  // 配方原料表格查询接口
  getFormulaRawNhfPage: params => instance.get('/nhf-app/formulaNhf/formulaRawNhfPage', { params }),

  // 配方营养需要量表格数据查询接口
  getFormulaNutritionNhfPage: params => instance.get('/nhf-app/formulaNhf/formulaNutritionNhfPage', { params }),

  // 获取配方详情
  getFormulaDetail: params => instance.get('/nhf-app/formulaManage/detail', { params }),

  // 送审
  sendAudit: data => instance.post('/nhf-app/oemFormulaManage/oemFormulaSendAuditSingle', data),

  // 批量送审
  batchSubmitForReview: data => instance.post('/nhf-app/oemFormulaManage/batchOemFormulaSendAudit', data),

  // 审核
  audit: data => instance.post('/nhf-app/oemFormulaManage/singleOemFormulaAudit', data),

  // 批量审核
  batchAudit: data => instance.post('/nhf-app/oemFormulaManage/batchOemFormulaAudit', data),

  // 复制
  copyOEMFormula: data => instance.post('/nhf-app/oemFormulaManage/confirmCopyOemFormula', data),

  // 新建
  saveOEMFormula: data => instance.post('/nhf-app/oemFormulaManage/createOemFormula', data),

  // 生成产品
  oemFormulaCreateProduct: data => instance.post('/nhf-app/oemFormulaManage/oemFormulaCreatePro', data),

  // 更新OEM配方审核状态
  updateOemFormulaAuditStatus: data => instance.post('/nhf-app/oemFormulaManage/updateOemFormulaAuditStatus', data),

  // 更新配方状态为已修改状态
  updateFormulaToModified: id => instance.post('/nhf-app/oemFormulaManage/updateOemFormulaAuditStatus', {
    auditStatus: 5,
    id: id
  }),

  // 获取产品价格信息
  getProductPrice: data => instance.post('/nhf-app/formulahis/getProductPrice', data),

  // 批量更新配方状态（显示/隐藏）
  batchUpdateFormulaStatus: data => instance.post('/nhf-app/formulaManage/batchUpdateFormulaStatus', data),
};
